import { cloneDeep } from 'lodash';

export const modifyFetchOptionsHeaders = (
  fetchOptions: RequestInit | (() => RequestInit) | undefined,
  headers: { [key: string]: string }
): RequestInit => {
  if (!fetchOptions) {
    return { headers };
  }

  const newFetchOptions = cloneDeep(
    typeof fetchOptions === 'object' ? fetchOptions : fetchOptions()
  );
  if (!newFetchOptions.headers) newFetchOptions.headers = {};

  newFetchOptions.headers = {
    ...newFetchOptions.headers,
    ...headers
  };

  return newFetchOptions;
};
